import { render } from "./ProdutoDetalhes.vue?vue&type=template&id=53de4562&scoped=true&ts=true"
import script from "./ProdutoDetalhes.vue?vue&type=script&lang=ts"
export * from "./ProdutoDetalhes.vue?vue&type=script&lang=ts"

import "./ProdutoDetalhes.vue?vue&type=style&index=0&id=53de4562&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53de4562"]])

export default __exports__